export const SEASON_START_KITCHEN_PATH = '/promo/pora-pora-dom-kuhnya/';

export const SEASON_START_KITCHEN_ELEMENT_BLOCK = 'landingStartSezonaKuhnya';

export const SEASON_START_KITCHEN_CDN_PATH = 'https://cdn.lemanapro.ru/lmru/image/upload/f_auto,c_pad,b_auto,d_photoiscoming.png/fudzi/elbrus/images/landings/season-start-kitchen';

export const SEASON_START_KITCHEN_LANDING_NAME = 'season-start-kitchen';

export const SEASON_START_KITCHEN_PRODUCTS = [
  {
    link: {
      href: '/catalogue/kuhonnye-garnitury/',
      title: 'Модульные кухни с установкой',
    },
    img: {
      alt: 'Баннер Модульные кухни с установкой',
      srcD: `${SEASON_START_KITCHEN_CDN_PATH}/banners/modular-kitchens-banner-ld.jpg/modular-kitchens-banner-ld.jpg`,
      srcT: `${SEASON_START_KITCHEN_CDN_PATH}/banners/modular-kitchens-banner-t.jpg/modular-kitchens-banner-t.jpg`,
      src: `${SEASON_START_KITCHEN_CDN_PATH}/banners/modular-kitchens-banner-m.jpg/modular-kitchens-banner-m.jpg`,
    }
  },
  {
    link: {
      href: '/offer/pora-pora-za-mezhkomnatnymi-dveryami-po-supercenam',
      title: 'Межкомнатные двери с установкой',
    },
    img: {
      alt: 'Баннер Межкомнатные двери с установкой',
      srcD: `${SEASON_START_KITCHEN_CDN_PATH}/banners/interior-doors-banner-ld.jpg/interior-doors-banner-ld-03.jpg`,
      srcT: `${SEASON_START_KITCHEN_CDN_PATH}/banners/interior-doors-banner-t.jpg/interior-doors-banner-t-03.jpg`,
      src: `${SEASON_START_KITCHEN_CDN_PATH}/banners/interior-doors-banner-m.jpg/interior-doors-banner-m-03.jpg`,
    }
  },
  {
    link: {
      href: '/offer/pora-pora-za-polami-po-supercenam',
      title: 'Ламинат с укладкой',
    },
    img: {
      alt: 'Баннер Ламинат с укладкой',
      srcD: `${SEASON_START_KITCHEN_CDN_PATH}/banners/laminate-banner-ld.jpg/laminate-baner-ld.jpg`,
      srcT: `${SEASON_START_KITCHEN_CDN_PATH}/banners/laminate-banner-t.jpg/laminate-banner-t.jpg`,
      src: `${SEASON_START_KITCHEN_CDN_PATH}/banners/laminate-banner-m.jpg/laminate-banner-m.jpg`,
    }
  },
  {
    link: {
      href: '/offer/pora-pora-za-keramogranitom-po-supercenam',
      title: 'Керамогранит с укладкой',
    },
    img: {
      alt: 'Баннер Керамогранит с укладкой',
      srcD: `${SEASON_START_KITCHEN_CDN_PATH}/banners/porcelain-stoneware-banner-ld.jpg/porcelain-stoneware-banner-ld.jpg`,
      srcT: `${SEASON_START_KITCHEN_CDN_PATH}/banners/porcelain-stoneware-banner-t.jpg/porcelain-stoneware-banner-t.jpg`,
      src: `${SEASON_START_KITCHEN_CDN_PATH}/banners/porcelain-stoneware-banner-m.jpg/porcelain-stoneware-banner-m.jpg`,
    }
  },
];

export const SEASON_START_KITCHEN_SOLUTIONS = [
  {
    link: {
      href: '/promo/pora-pora-uchastok/',
      title: 'Облагородим участок',
    },
    img: {
      alt: 'Баннер Облагородим участок',
      srcD: `${SEASON_START_KITCHEN_CDN_PATH}/banners/plot-banner-ld.jpg/plot-banner-ld-01.jpg`,
      srcT: `${SEASON_START_KITCHEN_CDN_PATH}/banners/plot-banner-t.jpg/plot-banner-t-01.jpg`,
      src: `${SEASON_START_KITCHEN_CDN_PATH}/banners/plot-banner-m.jpg/plot-banner-m-01.jpg`,
    }
  },
  {
    link: {
      href: '/promo/pora-pora-stroitelstvo/',
      title: 'Поможем построить',
    },
    img: {
      alt: 'Баннер Поможем построить',
      srcD: `${SEASON_START_KITCHEN_CDN_PATH}/banners/construction-banner-ld.jpg/construction-banner-ld-01.jpg`,
      srcT: `${SEASON_START_KITCHEN_CDN_PATH}/banners/construction-banner-t.jpg/construction-banner-t-01.jpg`,
      src: `${SEASON_START_KITCHEN_CDN_PATH}/banners/construction-banner-m.jpg/construction-banner-m-01.jpg`,
    }
  },
];
